import { useContext } from 'react';
import { AuthContext } from './../components';

export function useAuthContext() {
  return useContext(AuthContext);
}
